module.exports = __webpack_public_path__ + "static/img/notification-banner-button-sizing@3x.3d73d24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/notification-banner-button-sizing@3x.png
// module id = V95y
// module chunks = 0